import type { TFileStatus } from "@/store";

/**
 * Revantage APAC calls the generated artefact the "output", so the status that
 * follows generating it reads "Output Generated". Every other status keeps the
 * shell's wording. Passed to `StatusBadge` and `FilesTable`; keep it a
 * module-level constant, since `FilesTable` memoises on it.
 */
export const APAC_STATUS_LABELS = {
    finjournal_generated: "Output Generated",
} satisfies Partial<Record<TFileStatus, string>>;
